import { authActions } from '../reducers/authSlice';
import { getPoints, logoutUser } from '../services/Api/User/UserService';
import { setSavedCoupons, setSavedDrugs } from './userDrug';
import { modalActions } from '../reducers/modalSlice';

export const getUserPoints = mProspectId => {
  return async dispatch => {
    try {
      const points = await getPoints(mProspectId);
      dispatch(
        authActions.userpoints({
          userPoints: points
        })
      );
    } catch (error) {
      console.log('Error::', error);
    }
  };
};

export const logoutClearStore = () => {
  return async dispatch => {
    logoutUser();
    dispatch(authActions.logout());
    dispatch(setSavedCoupons({}));
    dispatch(setSavedDrugs({}));
    dispatch(modalActions.clearModal());
    dispatch(authActions.sessionExpired({ isServerSessionValid: false }));
  };
};

export const SessionExpiredAndClearStore = () => {
  return async dispatch => {
    dispatch(authActions.sessionExpired({ isServerSessionValid: true }));
  };
};

export const deleteClearStore = () => {
  return async dispatch => {
    logoutUser();
    dispatch(authActions.logout());
    dispatch(setSavedCoupons({}));
    dispatch(setSavedDrugs({}));
  };
};
